import './Starfield.css';

function Starfield() {
  return (
    <>
      <div className="starfield starfield-a" aria-hidden="true" />
      <div className="starfield starfield-b" aria-hidden="true" />
    </>
  );
}

export default Starfield;
